export default __webpack_public_path__ + "static/assets/im_organisation.62e72ffd9f0c7cfa38a7e9443b2249ab.png";